import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ResultOutcome() {
  return (
    <section className="centerimg_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>
              What <span style={{ color: "#198463" }}>Outcomes?</span>
            </h2>
            <p>
              Our goal was to provide an application to users that would make
              the navigation in the app seamless and user-friendly.
            </p>
            <p>
              Overall, with this app, customers don’t need to visit the stores
              separately in order to purchase products. Instead, they can easily
              compare and find distinct products’ prices and features available
              on the platforms within the application.
            </p>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <div className="img_come">
              <StaticImage
                src="../../../images/case-studies/save-win/tek_img_06.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1062}
                height={529}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResultOutcome;
